import { useEnmonServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateDemoUserDto } from 'lib/services';
import { useMutation } from 'react-query';

export const useCreateDemoAccount = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { users } = useEnmonServices();

  const notify = useAppNotifications();

  return useMutation({
    mutationFn: async (userDto: CreateDemoUserDto) => await users.createDemoUser(userDto),
    onSuccess: () => {
      notify.success({
        message: 'Demo account created',
      });
      onSuccess?.();
    },
    onError: e => {
      notify.error({
        message: 'Failed to create demo account',
        description: e instanceof Error ? e.message : undefined,
      });
    },
  });
};
